import React from 'react';
import PropTypes from 'prop-types';

import LazyLoadImg from '../shared/LazyLoadImg';
import { sizedImageShape } from '../../../types';

const Highlight = ({ description, icon, link, linkLabel, target, title }) => {
  return (
    <div className="highlight">
      <LazyLoadImg src={icon} alt="highlight icon" />
      <h3>
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </h3>
      {description && <h4 dangerouslySetInnerHTML={{ __html: description }} />}
      {link && (
        <a href={link} aria-label={linkLabel} {...target && { target }}>
          Read more
        </a>
      )}
    </div>
  );
};

Highlight.defaultProps = {
  description: null,
  link: null,
  linkLabel: '',
  target: null,
  title: null
};

Highlight.propTypes = {
  description: PropTypes.string,
  icon: sizedImageShape.isRequired,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string
};

export default Highlight;
